"use client";

import { useRef } from "react";

import { Container } from "@/src/components/ui/Container";
import Section from "@/src/components/ui/Section";
import { Heading, Text } from "@/src/components/ui/Typography";
import { StickyColumnUntilLevel } from "@/src/components/molecules/StickyColumnUntilLevel";

interface ClientExpectationsProps {
  items: string[];
}

export function ClientExpectations({ items }: ClientExpectationsProps) {
  const boundsRef = useRef<HTMLDivElement>(null);

  if (items.length === 0) return null;

  return (
    <Section className="bg-white pb-0">
      <Container>
        <div className="grid gap-6 md:grid-cols-2 md:gap-24">
          <StickyColumnUntilLevel boundsRef={boundsRef} className="h-fit self-start">
            <Heading as="h2" size="displayLG">
              Client Expectations
            </Heading>
          </StickyColumnUntilLevel>

          <div ref={boundsRef} className="flex flex-col gap-8">
            {items.map((item, index) => (
              <div key={index} className="flex gap-4">
                <span className="mt-3 h-2 w-2 shrink-0 rounded-full bg-neutral-700" />

                <Text size="bodyLG" className="text-neutral-700">
                  {item}
                </Text>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </Section>
  );
}
